import { render, staticRenderFns } from "./settingPermissions.vue?vue&type=template&id=5ce9ceea&scoped=true&"
import script from "./settingPermissions.vue?vue&type=script&lang=js&"
export * from "./settingPermissions.vue?vue&type=script&lang=js&"
import style0 from "./settingPermissions.vue?vue&type=style&index=0&id=5ce9ceea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9ceea",
  null
  
)

export default component.exports